import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import CompleteUsersService from "@/services/api/completeUsers";
import type { CompleteUsersResponse, CompleteUserSortBy } from "@/services/api/completeUsers";
import type { SortOrder } from "@/services/api/incompleteUsers";

export const completeUsersKeys = {
  all: ["complete-users"] as const,
  list: (page: number, limit: number, sortOrder: SortOrder, sortBy?: CompleteUserSortBy, search?: string | null) =>
    [...completeUsersKeys.all, { page, limit, sortOrder, sortBy, search: search ?? "" }] as const,
};

interface UseCompleteUsersParams {
  page: number;
  limit: number;
  sortOrder?: SortOrder;
  sortBy?: CompleteUserSortBy;
  search?: string | null;
  enabled?: boolean;
}

export function useCompleteUsers({
  page,
  limit,
  sortOrder = "desc",
  sortBy,
  search,
  enabled = true,
}: UseCompleteUsersParams) {
  return useQuery<CompleteUsersResponse>({
    queryKey: completeUsersKeys.list(page, limit, sortOrder, sortBy, search),
    queryFn: async () => {
      try {
        return await CompleteUsersService.getCompleteUsers({
          limit,
          offset: (page - 1) * limit,
          search,
          sortBy,
          sortOrder,
        });
      } catch (error: any) {
        toast.error(error?.message || "Failed to fetch complete users");
        throw error;
      }
    },
    placeholderData: (previousData) => previousData,
    enabled,
  });
}
